import { GameStatisticsState } from '../interfaces';
import { GameStatisticsStoreStatus } from '../enums';

export const initialState: GameStatisticsState = {
  entity: null,
  status: {
    [GameStatisticsStoreStatus.Loading]: [],
  },
};
